import React from "react";
import { STATUS_META, MONTHS } from "@/lib/constants";

export default function MonthCalendar({ year, month, days }) {
  const map = {};
  (days || []).forEach((d) => (map[d.date] = d.status));

  const first = new Date(year, month - 1, 1);
  const startWeekday = first.getDay();
  const daysInMonth = new Date(year, month, 0).getDate();

  const cells = [];
  for (let i = 0; i < startWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-head font-bold text-slate-900">{MONTHS[month - 1]} {year}</h3>
      </div>
      <div className="grid grid-cols-7 gap-1.5 mb-2">
        {["S", "M", "T", "W", "T", "F", "S"].map((d, i) => (
          <div key={`wd-${i}`} className="text-center text-[11px] font-semibold text-slate-400 py-1">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1.5">
        {cells.map((d, i) => {
          if (!d) return <div key={`empty-${i}`} />;
          const iso = `${year}-${pad(month)}-${pad(d)}`;
          const status = map[iso];
          const meta = status ? STATUS_META[status] : null;
          return (
            <div
              key={iso}
              data-testid={`calendar-cell-${iso}`}
              className={`aspect-square rounded-lg flex flex-col items-center justify-center text-sm font-medium border ${
                meta ? `${meta.dot} text-white border-transparent` : "bg-slate-50 text-slate-400 border-slate-100"
              }`}
            >
              {d}
            </div>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1.5 mt-4">
        {Object.entries(STATUS_META).map(([k, m]) => (
          <div key={k} className="flex items-center gap-1.5 text-[11px] text-slate-500">
            <span className={`h-2.5 w-2.5 rounded-full ${m.dot}`} /> {m.label}
          </div>
        ))}
      </div>
    </div>
  );
}
